(() => {
  'use strict';

  angular
    .module('uwAgenda.email')
    .controller(
      'EyeFileIntegrationModalController',
      ['$uibModalInstance', 'HelperService', '$translate', 'Alert', 'IntegrationService', 'SharedAgendaService', 'id', EyeFileIntegrationModalControllerFn]);

  function EyeFileIntegrationModalControllerFn($uibModalInstance, HelperService, $translate, Alert, IntegrationService, SharedAgendaService, id) {
    const vm = this;

    activate();

    function activate() {
      IntegrationService
        .getIntegrationsById(id)
        .then(onLoadedIntegration);
      
      getAgendas();

      vm.close = () => {
        $uibModalInstance.dismiss("abort");
      };
    }

    function onLoadedIntegration(integration) {
      vm.eyeFileIntegration = integration;
    }

    vm.copyText = (text) => {
      HelperService.copyTextToClipboard(text);
      const confirmation = $translate.instant('value_copied', {value: text});
      Alert.info(confirmation);
    };
    
    function getAgendas() {
      const uniqueAgendas = new Map();
      vm.agendasInIntegration = SharedAgendaService.data.agendas.map(agenda => ({
        text: `${agenda.owner.caption}: ${agenda.agendaGuid}`,
        id: agenda.id
      }))
          .filter(agenda => {
            if (!uniqueAgendas.has(agenda.id)) {
              uniqueAgendas.set(agenda.id, true);
              return true;
            }
            return false;
          });
    }
  }
})();